export function getUserRole(permissions?: Record<any, any>) {
    const userRole = permissions && permissions.role;

    let roleTitle = '';

    if (userRole != null) {
        ('#bfd730');
        switch (userRole) {
            case 'OWNER':
                roleTitle = 'Owner';
                // roleDesc = 'You have full access.';
                // color = '#bfd730';
                break;
            case 'TEAM_MANAGER':
            case 'MANAGER':
                roleTitle = 'Manager';
                // roleDesc = 'You have full access.';
                // color = '#bfd730';
                break;
            case 'EXECUTIVE':
                roleTitle = 'Executive';
                // roleDesc = 'Some tools may not be available for you';
                // color = '#ffa726';
                break;
            case 'OPERATOR':
                roleTitle = 'Operator';
                // roleDesc = 'Some tools may not be available for you';
                // color = '#ffa726';
                break;
            case 'VIEW_ONLY':
                roleTitle = 'View Only';
                // roleDesc = 'Some tools may not be available for you.';
                // color = '#D50000';
                break;
        }
    }

    return roleTitle;
}